const initialState = {
  fetched: false,
  data: null,
  _default_spec: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'WEALTH_MANAGEMENT_MODULE_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, {
          fetched: true,
          data: action.payload,
        });
      } else {
        return Object.assign({}, state, {
          fetched: true,
          data: null,
        });
      }
    default:
      return state;
  }
};
